import {
  makePercent,
  Percent,
  PositionReward,
  ProtectedAprAsset,
} from "@silo/types";
import { Array, BigInt, pipe } from "effect";
import { byAprDesc } from "./rewards";

export interface ProtectedAprMetrics {
  totalProtectedRewardsApr: Percent;
  totalProtectedApr: Percent;
  hasProtectedRewards: boolean;
  hasProtectedIncentives: boolean;
  protectedRewards: PositionReward[];
}

export function getProtectedAprMetrics(
  asset: ProtectedAprAsset,
  nativeRewardsSymbol: string
): ProtectedAprMetrics {
  const { protectedRewardsApr, protectedMerklRewards } = asset;

  const totalProtectedRewardsApr = pipe(
    [protectedRewardsApr, ...protectedMerklRewards.map((reward) => reward.apr)],
    BigInt.sumAll,
    makePercent
  );

  const totalProtectedApr = totalProtectedRewardsApr;

  const hasProtectedRewards = totalProtectedRewardsApr > 0n;
  const hasProtectedIncentives = hasProtectedRewards;

  const nativeReward: PositionReward = {
    rewardTokenSymbol: nativeRewardsSymbol,
    apr: protectedRewardsApr,
    isSuperFest: false,
  };

  const protectedRewards: PositionReward[] = pipe(
    [nativeReward, ...protectedMerklRewards],
    Array.filter((reward) => reward.apr > 0n),
    Array.sort(byAprDesc)
  );

  return {
    totalProtectedRewardsApr,
    totalProtectedApr,
    hasProtectedRewards,
    hasProtectedIncentives,
    protectedRewards,
  };
}
